import { MaybeRef } from '@vueuse/core';

const MAXIMUM_NAME_LENGTH = 24;

const WATCHLIST_QUERY_KEYS = {
  watchlist: ['watchlist-names'],
  watchlistItems: (watchlistId: MaybeRef<string | null | undefined>) => [
    'watchlist-items',
    watchlistId,
  ],
  watchlistOverview: ['watchlist-overview-names'],
};

export { MAXIMUM_NAME_LENGTH, WATCHLIST_QUERY_KEYS };
